import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const AnalyticsIcon: React.FC<OneColorIconProps> = ({ className, color = 'white', size = 32 }) => {
  const hex = getHexColor(color)

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={hex}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M15 16.6654V8.33203" stroke="#141414" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 16.6654V3.33203" stroke="#141414" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 16.668V11.668" stroke="#141414" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
